import React from "react";

export type InsideLayoutContextType = {
    subHeaderText: string;
    subHeaderDetail?: React.ReactNode;
    menuOpened: boolean;
    setMenuOpened: (open: boolean) => void;
    toogleMenu: () => void;
    showCloseButtonWhileMenuOpened: boolean;
    changeSubHeaderText: (value: string) => void;
    changeSubHeaderDetail: (value: React.ReactNode) => void;
    closeMenuText: string;
};

export const InsideLayoutContext = React.createContext<InsideLayoutContextType>(null!);

export const useInsideLayout = () => React.useContext(InsideLayoutContext);
